import { Action, ActionTypes } from "./actions"

export interface StepConfig {
    active: boolean
    visible: boolean
}

export interface StepControlsState {
    activeStep: number
    next: StepConfig
    back: StepConfig
}

export const getInitialState = (): StepControlsState => {
    return {
        activeStep: 0,
        next: {
            active: true,
            visible: true
        },
        back: {
            active: true,
            visible: true
        }
    }
}

export const reducer = (state: StepControlsState, action: Action): StepControlsState => {
    switch (action.type) {
        case ActionTypes.ADVANCE_STEPPER:
            return {
                ...state,
                activeStep: state.activeStep + 1
            }
        case ActionTypes.REVERSE_STEPPER:
            return {
                ...state,
                activeStep: state.activeStep - 1
            }
        case ActionTypes.UPDATE_NEXT_STEP_CONFIG:
            return {
                ...state,
                next: {
                    ...state.next,
                    ...action.config
                }
            }
        case ActionTypes.UPDATE_BACK_STEP_CONFIG:
            return {
                ...state,
                back: {
                    ...state.back,
                    ...action.config
                }
            }
        case ActionTypes.RESET:
            return getInitialState()
        default:
            return state
    }
}
